package gr.tech.site.styles

import com.varabyte.kobweb.compose.css.BoxShadow
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*

// Controls how many team member cards are visible in the slider at once.
// 1 card (100%) on mobile, 3 cards (33.33%) on md+.
val TeamSliderStyle = CssStyle {
    base {
        Modifier.styleModifier {
            property("--team-card-width", "100%")
        }
    }
    Breakpoint.MD {
        Modifier.styleModifier {
            property("--team-card-width", "calc(100% / 3)")
        }
    }
}

val FeaturedPersonCardStyle = CssStyle {
    base {
        Modifier
            .borderRadius(16.px)
            .padding(2.5.cssRem)
            .fillMaxWidth()
    }
    // Keep the "learn more" span hidden by default via CSS (not inline style)
    cssRule(" span") {
        Modifier
            .translateY((-30).percent)
            .opacity(0)
            .transition(Transition.all(250.ms))
    }
    // Reveal on card hover
    cssRule(":hover span") {
        Modifier
            .translateY((0).percent)
            .opacity(1)
    }
}

val TeamMemberCardStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.WhiteSmoke)
            .border(1.px, LineStyle.Solid, Theme.MediumGreen.rgb)
            .borderRadius(8.px)
            .padding(1.5.cssRem)
            .boxShadow(
                BoxShadow.of(
                    offsetX = 0.px,
                    offsetY = 4.px,
                    blurRadius = 16.px,
                    spreadRadius = 0.px,
                    color = rgba(0, 0, 0, 0.1)
                )
            )
            .transition(Transition.all(250.ms))
    }
    hover {
        Modifier
            .translateY((-3).px)
    }
}

val TeamMemberHeadshotStyle = CssStyle.base {
    Modifier
        .width(120.px)
        .height(120.px)
        .borderRadius(50.percent)
        .objectFit(ObjectFit.Cover)
}

val FeaturedPersonImageStyle = CssStyle.base {
    Modifier
        .width(150.px)
        .height(150.px)
        .objectFit(ObjectFit.Cover)
}
